export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE'
export const CLEAR_ERROR_MESSAGE = 'CLEAR_ERROR_MESSAGE'
export const CLEAR_INPUT_ERROR_MESSAGE = 'CLEAR_INPUT_ERROR_MESSAGE'

export const HANDLE_ERROR_MESSAGES_DONE = 'HANDLE_ERROR_MESSAGES_DONE'
export const HANDLE_ERROR_MESSAGES_FAIL = 'HANDLE_ERROR_MESSAGES_FAIL'